import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthEnforcer"] */ "/app/components/auth-enforcer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CacheVersionChecker"] */ "/app/components/cache-version-checker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientConsoleGate"] */ "/app/components/client-console-gate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StylesReadyProvider"] */ "/app/components/styles-ready-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/lib/auth.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PermissionProvider"] */ "/app/lib/permission-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/lib/theme-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccessibleFeaturesProvider"] */ "/app/lib/use-accessible-features.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-cc-sans\",\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"display\":\"swap\"}],\"variableName\":\"ccSans\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"JetBrains_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-cc-mono\",\"weight\":[\"300\",\"400\",\"500\"],\"display\":\"swap\"}],\"variableName\":\"ccMono\"}");
